export default "__VITE_ASSET__d96f65dd__"